/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteFacilityRegion200ResponseData } from './DeleteFacilityRegion200ResponseData';
import {
    DeleteFacilityRegion200ResponseDataFromJSON,
    DeleteFacilityRegion200ResponseDataFromJSONTyped,
    DeleteFacilityRegion200ResponseDataToJSON,
} from './DeleteFacilityRegion200ResponseData';

/**
 * 
 * @export
 * @interface DeleteFacilityRegion200Response
 */
export interface DeleteFacilityRegion200Response {
    /**
     * 
     * @type {DeleteFacilityRegion200ResponseData}
     * @memberof DeleteFacilityRegion200Response
     */
    data?: DeleteFacilityRegion200ResponseData;
}

/**
 * Check if a given object implements the DeleteFacilityRegion200Response interface.
 */
export function instanceOfDeleteFacilityRegion200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteFacilityRegion200ResponseFromJSON(json: any): DeleteFacilityRegion200Response {
    return DeleteFacilityRegion200ResponseFromJSONTyped(json, false);
}

export function DeleteFacilityRegion200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityRegion200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DeleteFacilityRegion200ResponseDataFromJSON(json['data']),
    };
}

export function DeleteFacilityRegion200ResponseToJSON(value?: DeleteFacilityRegion200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteFacilityRegion200ResponseDataToJSON(value.data),
    };
}

